<rt-group variant="horizontal stacked">
  @if (editable && isCvEmpty) {
    <rt-button [disabled]="loading || processing" (click)="uploadClick()" variant="outline">
      <rt-icon name="file-upload" />
      <span>{{ 'app.candidate.upload_file' | translate }}</span>
    </rt-button>
  }
  @if (originalUrl && !isCvEmpty) {
    <a
      rt-icon-button
      [rtTooltip]="
        (isAnonymized() && !anonymizationFailed
          ? 'app.candidate.anonymization.download_anonymized_file'
          : 'app.candidate.download_original_file'
        ) | translate
      "
      [rtTooltipPosition]="tooltipPosition()"
      [disabled]="loading"
      [href]="originalUrl"
      download
      variant="outline"
      iconName="file-download"
      shape="square"
    ></a>
  }
  @if (url && !isCvEmpty) {
    <a
      rt-icon-button
      [disabled]="loading"
      [rtTooltip]="'app.candidate.open_in_tab' | translate"
      [rtTooltipPosition]="tooltipPosition()"
      [href]="url"
      target="_blank"
      variant="outline"
      iconName="open-in-new"
      shape="square"
    ></a>
  }
  @if (editable) {
    @if (editable && !isCvEmpty) {
      <rt-icon-button
        #moreDropdownOrigin="rtOverlayOrigin"
        rt-overlay-origin
        [rtTooltip]="'app.common.more' | translate"
        [rtTooltipPosition]="tooltipPosition()"
        [disabled]="loading"
        [pressed]="dropdownOpen"
        (click)="toggleDropdown(true)"
        variant="outline"
        iconName="more-horiz"
        shape="square"
      />
      <ng-template
        #moreDropdown="rtConnectedOverlay"
        rt-connected-overlay
        hasBackdrop
        [origin]="moreDropdownOrigin"
        [open]="dropdownOpen"
        (backdropClick)="toggleDropdown(false)"
      >
        <rt-dropdown [width]="DropdownWidth.SmallX">
          <rt-dropdown-item (click)="uploadClick(); toggleDropdown(false)">
            <rt-icon prefix size="small" name="file-upload" />
            {{ 'app.candidate.upload_new_file' | translate }}
          </rt-dropdown-item>
          <rt-dropdown-item (click)="reparseClick(); toggleDropdown(false)">
            <rt-icon prefix size="small" name="autorenew" />
            {{ 'app.candidate.reparse_file' | translate }}
          </rt-dropdown-item>
          <rt-dropdown-item (click)="deleteClick(); toggleDropdown(false)">
            <rt-icon prefix size="small" name="delete" />
            {{ 'app.candidate.delete_file' | translate }}
          </rt-dropdown-item>
        </rt-dropdown>
      </ng-template>
    }
  }
</rt-group>
